module.exports = __webpack_public_path__ + "h5/img/call.000280ea.png";